import React, { useState, useEffect, useContext, useMemo } from "react";
import "./services.scss";
import axios from "axios";
import Category from "../../common/category";
import { useParams } from "react-router-dom";
import Grid from "../../common/grid";
import Breadcrumbs from "../../common/breadcumb";
import { TabTitle } from "../../common/dynamicTitle";
import { LangContext } from "../../context/LangContext";

function List() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  const { slug } = useParams();
  TabTitle(`GMBF | ${slug}`);

  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const API_URL = `${process.env.REACT_APP_URL}service/all`;
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(false);

      try {
        const response = await axios.get(API_URL);
        setService(response.data.items);
      } catch (err) {
        console.error("Failed to fetch services:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [slug]);

  // console.log("service", service);
  const mainData = useMemo(() => {
    if (!service) return [];
    return nep ? service.ne : service.en;
  }, [service, nep]);
  const pageTitle = useMemo(() => {
    return nep ? "सेवाहरू" : "Services";
  }, [nep]);
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Something went wrong. Please try again later.</p>;

  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />
      <div className="service-parent">
        <div className="wrapper">
          <div className="Service-container">
            <section>
              {mainData.map((cat) => (
                <Grid key={cat.id} grid={cat} url={`../services/`} nep={nep} />
              ))}
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default List;
